import React from 'react'
import { slugify } from '@utils/slugify'
import { calculateReadTime } from '@utils/readTime'
import { ContentCard } from '@components/ui/ContentCard'
import type { BlogPost } from '@data/types'

interface BlogCardProps {
  post: BlogPost
  showSocial?: boolean
}

export const BlogCard: React.FC<BlogCardProps> = ({
  post,
  showSocial = false,
}) => {
  if (!post.title) return null

  // generate slug, readTime
  const slug = slugify(post.title)
  const readTime =
    post.content && post.content.trim().length > 0
      ? `${calculateReadTime(post.content)} min`
      : undefined

  return (
    <ContentCard
      id={post.id}      title={post.title}
      description={post.excerpt}
      image={post.image}
      date={post.date}
      tags={post.tags}
      internalLink={`/blog/${slug}`}
      categoryLabel={post.category}
      readTime={readTime}
      showSocial={showSocial}
    />
  )
}
